import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import Client from '../Client/Client'
import { IPermission } from '../Client/IPermission'

import {
  ActionTypes,
  GET_USER_PERMISSIONS,
  GET_USER_PERMISSIONS_FAILURE,
  GET_USER_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS,
  UPDATE_PERMISSIONS_FAILURE,
  UPDATE_PERMISSIONS_SUCCESS,
} from './ActionTypes'
import { IUserPermissionState } from './IUserPermissionState'

export const getUserPermissions = (
  userId: number,
): ThunkAction<any, IUserPermissionState, undefined, ActionTypes> => {
  return (dispatch: ThunkDispatch<IUserPermissionState, undefined, any>) => {
    dispatch({
      type: GET_USER_PERMISSIONS,
    })

    return Client.getUserPermissions(userId)
      .then(userPermissions =>
        dispatch(getUserPermissionsSuccess(userPermissions)),
      )
      .catch(() => dispatch(getUserPermissionsFailure()))
  }
}

const getUserPermissionsSuccess = (
  userPermissions: IPermission[],
): ActionTypes => {
  return {
    type: GET_USER_PERMISSIONS_SUCCESS,
    payload: {
      userPermissions,
    },
  }
}

const getUserPermissionsFailure = (): ActionTypes => {
  return {
    type: GET_USER_PERMISSIONS_FAILURE,
  }
}

const updatePermissionsSuccess = (): ActionTypes => {
  return {
    type: UPDATE_PERMISSIONS_SUCCESS,
  }
}

const updatePermissionsFailure = (): ActionTypes => {
  return {
    type: UPDATE_PERMISSIONS_FAILURE,
  }
}

export const updatePermissions = (
  permissions: IPermission[],
): ThunkAction<any, IUserPermissionState, undefined, ActionTypes> => {
  return (dispatch: ThunkDispatch<IUserPermissionState, undefined, any>) => {
    dispatch({
      type: UPDATE_PERMISSIONS,
      payload: {
        permissions,
      },
    })

    return Client.updatePermissions(permissions).then(
      () => dispatch(updatePermissionsSuccess()),
      () => dispatch(updatePermissionsFailure()),
    )
  }
}
